import {useSelector} from 'react-redux';
import {useDictionary} from './useDictionary';
import {selectDictionaries} from 'slices';
import {ParamsType} from 'types/common';

type useEnumDictionaryProps = {
    code: string;
    stop?: boolean;
    initialDictParams?: ParamsType;
};

export const useEnumDictionary = ({code, stop, initialDictParams}: useEnumDictionaryProps) => {
    useDictionary({code, enumDict: true, fromStore: true, need: !stop, initialDictParams});
    const dictionaries = useSelector(selectDictionaries);
    const dictionaryFull = dictionaries[code] || [];
    const dictionaryOptions = dictionaryFull.map((el) => el.code!);
    const getOptionNameByCode = (code?: string | null) =>
        dictionaryFull.find((el) => el.code === code)?.displayName || '';

    return {
        dictionaryFull,
        dictionaryOptions,
        getOptionNameByCode,
    };
};
